<template>
   <div class="col-12 col-md-12 col-lg-6 col-xl-4 py-2">
      <div class="card-wrapper card-space">
         <div class="card card-bg no-after" 
            :class="[
               {[`bg-${type}`]: type},
               {['card-img']: typeof(news.item._source.data.immagineUnsplash) !== 'undefined' || news.item._source.data.immagineUnsplash !== null},
            ]">
            <div>
               <div class="category-top d-flex justify-content-between" v-if="news.item._source.schema || news.item._source.lastModified">
                  <div class="category text-uppercase" >{{ getArea }}</div>
                  <div class="date text-uppercase">{{ transformDate(news.item._source.lastModified) }}</div>
               </div>            
               <div class="img-responsive-wrapper" v-if="typeof(news.item._source.data.immagineUnsplash) == 'object'">
                  <div class="img-responsive">
                     <figure class="img-wrapper">
                        <img :src="news.item._source.data.immagineUnsplash.iv[0].immagine+'&q=75&w=480'">                     
                     </figure>
                  </div>
               </div>            
            </div>   

            <!-- Body -->
            <div class="card-body" :class="bodyClasses" v-if="!noBody">
               <!-- Layout of card if NO image present -->       
               <router-link :to="link" :params="{slug: news.item._source.data.slug.iv, id: news.item._source.id, type: news.item._source.name  }" >
                  <h5 class="card-title">
                     <span v-if="news.item._source.data.titolo !== undefined">{{news.item._source.data.titolo.iv}}</span>
                     <span v-if="news.item._source.data.titolo === undefined">{{news.item._source.data.nome.iv}}</span>
                  </h5>  
               </router-link>

               <p class="card-text" v-if="news.item._source.data.breve !== undefined">{{news.item._source.data.breve.iv}}</p>

               <div class="head-tags mt-auto mb-2" v-if="news.item._source.data.argomenti">
                  <h6 class="x-small font-weight-semibold d-none">Tag</h6>
                  <div class="align-items-center  mt-4 mt-md-0">
                     <argomento v-for="(argomento, val) in news.item._source.data.argomenti.iv" :tag="argomento" :key="val"></argomento>
                     
                     <span v-if="news.item._source.data.s3 !== undefined && news.item._source.data.s3.iv !== null && getArgumentS3(news.item._source.data.s3.iv).length > 0">
                        <argomento v-for="(argument) in getArgumentS3(news.item._source.data.s3.iv)" :key="argument.id" :tag="argument.nome" :linkHref="argument.linkUrl" />                                                
                     </span>    

                  </div>
               </div>
            </div>
            <!-- Body End -->

            <!-- Footer -->
            <div class="it-card-footer" v-if="!noFooter">
               <div class="separator">       
                  <router-link :to="link" :params="{slug: news.item._source.data.slug.iv, id: news.item._source.id, type: news.item._source.name }">
                     <span class="read-more">Leggi di più</span><svg class="icon">
                     <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="img/sprite.svg#it-arrow-right"></use></svg>
                  </router-link>                     
                  <div class="d-flex ml-auto">
                     <shareArea :hasLabel="false" :url="link" />
                  </div>                  
               </div>
            </div>    
            <!-- Footer End -->
         </div>
      </div>
   </div>
</template>
<script>
import {getDate} from '@/service';
import ShareArea from "@/components/ShareArea";
import argomento from "@/components/Arguments.vue";

export default {
   name: "result",
   components:{
      ShareArea,
      argomento
   },

   props: {
      type: {
        type: String,
        description: "Card type"
      },
      path: {
        type: String,
        default: "",
        description: "Card path"
      },         
      news: {
        type: Object,
        description: "News item object"
      },     
      area: {
        type: String,
        description: "La categoria che l'articolo si partiene"
      },        
      noBody: {
        type: Boolean,
        default: false,
        description: "Whether card should have wrapper body class"
      },
      noFooter: {
        type: Boolean,
        default: false,
        description: "Whether card should have a footer"
      },            
      bodyClasses: {
        type: [String, Object, Array],
        description: "Card body css classes"
      }
   },

   methods:{
      transformDate: function(val){
         return getDate(val);
      },
      getArgumentS3(id){
         return this.$root.getS3Category(id);
      },   
      getPath(id){       
         let areaS3 = this.$root.getS3Category(id);
         return areaS3[id].linkUrl;
      },
      getNameSezione(id){
         let areaS3 = this.$root.getS3Category(id);
         return areaS3[id].nome;
      },
      getAreeSpeciali(id,type){
         let areeSpec = this.$root.getAreeSpeciali(new Array(id));
         return (areeSpec[id] !== undefined ? (type == 'name' ? areeSpec[id].titolo : areeSpec[id].slug ) : '...');
      }
   },

   computed:{
      link: function () {        
         let nameType = this.$props.news.item._source.name;

         if(nameType === "S3Published"){
            return "/s3/" + this.$props.news.item._source.data.slug.iv;
         }
         else if(nameType === "SezionePublished"){
            return "/" + this.$props.news.item._source.data.slug.iv;               
         }
         else if(nameType === "ArticoloPublished"){
            if(this.$props.news.item._source.data.s3.iv !== null && (this.$props.news.item._source.data.s3 !== undefined  && this.$props.news.item._source.data.s3.iv.length > 0)){
               return this.getPath(this.$props.news.item._source.data.s3.iv) +'/'+ this.$props.news.item._source.data.slug.iv;            
            }
            else if( this.$props.news.item._source.data.areeSpecializzazione.iv !== null && (this.$props.news.item._source.data.areeSpecializzazione !== undefined && this.$props.news.item._source.data.areeSpecializzazione.iv.length > 0)){
               return "/aree-di-specializzazione/" + this.getAreeSpeciali(this.$props.news.item._source.data.areeSpecializzazione.iv, 'slug') +'/'+ this.$props.news.item._source.data.slug.iv;
            }
            else{
               return "/s3/" + this.$props.news.item._source.data.slug.iv;
            }
         }
         else if(nameType === "AreeSpecializzazionePublished"){
            return "/aree-di-specializzazione/" + this.$props.news.item._source.data.slug.iv;
         }
         else if(nameType === "PartecipantePublished"){
             return "/partecipanti/" + this.$props.news.item._source.data.slug.iv;
         }
         else if(nameType === "EventoPublished"){
             return "/eventi/" + this.$props.news.item._source.data.slug.iv;
         }   
         else if(nameType === "PrivacyPolicyUpdated" || nameType === "CookiePolicyUpdated"){
             return "/" + this.$props.news.item._source.data.slug.iv;
         }                   
         else{
            return "/notizie/" + this.$props.news.item._source.data.slug.iv;            
         }
      },

      getArea: function(){
         let typeArea = this.$props.news.item._source.schemaId.split(',').pop();
       
         if(typeArea == 'articolo' && (this.$props.news.item._source.data.s3.iv == null && this.$props.news.item._source.data.areeSpecializzazione.iv == null) ){
            return "S3"; 
         }
         else if(typeArea == 'articolo' && 
              ( this.$props.news.item._source.data.s3 !== undefined && 
               this.$props.news.item._source.data.s3.iv !== null && 
               this.$props.news.item._source.data.s3.iv.length > 0) ) {
            return this.getNameSezione(this.$props.news.item._source.data.s3.iv);                       
         }
         else if(typeArea == 'articolo' &&
              ( this.$props.news.item._source.data.areeSpecializzazione !== undefined &&
               this.$props.news.item._source.data.areeSpecializzazione.iv !== null &&
               this.$props.news.item._source.data.areeSpecializzazione.iv.length > 0) ) {
            return this.getAreeSpeciali(this.$props.news.item._source.data.areeSpecializzazione.iv, 'name');
         }
         else{
            return typeArea.replace('-', ' ');
         }
      },            
   }
};
</script>
<style scoped>
.read-more {
   color: #003594;
   text-transform: uppercase;
   font-weight: bold;
   letter-spacing: .9px;
   font-size: .77778rem;
}
</style>
